import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { LogisticService, PohCompletionMethodItem, ProdBeoMethodItem, ProductionPlaceItem } from '@app/services/logistic.service';
import { BookingGroupItem, ProductGet, ProductItem, ProductService } from '@app/services/product.service';
import { forkJoin, from, ReplaySubject, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'tt-product-production-form',
    templateUrl: './product-production-form.component.html',
    styleUrls: ['./product-production-form.component.css'],
})
export class ProductProductionFormComponent {
    @Input()
    public set params(value: ProductGet | undefined) {
        this.setParams(value);
    }
    public get params() {
        return this._params;
    }
    private _params?: ProductGet;

    @Output()
    public paramsChange = new EventEmitter<ProductGet>();

    private setParams(value: ProductGet | undefined) {
        this._params = value;

        if (!!value) {
            this.params$.next(value);
        }
    }

    private destroy$ = new Subject<void>();

    private params$ = new ReplaySubject<ProductGet>(1);

    public productionPlaces: ProductionPlaceItem[] = [];

    public completionMethods: PohCompletionMethodItem[] = [];

    public productionOrderMethods: ProdBeoMethodItem[] = [];

    public bookingGroups: BookingGroupItem[] = [];

    constructor(
        private product: ProductService,
        private logistic: LogisticService,
        private cdr: ChangeDetectorRef,
    ) {}

    public searchProducts = async () => {
        return this.product.getProducts({ prod_name: this.params?.prod_name_planning ?? '' });
    };

    public onProductPlanningSelected(event?: ProductItem) {
        if (!this.params) return;

        this.params.prod_id_planning = event?.item_id ?? '';
        this.params.prod_name_planning = event?.item_name ?? '';
        this.onChanged('prod_id_planning');
        this.cdr.markForCheck();
    }

    public onChanged(key: keyof ProductGet) {
        if (!this.params) return;

        this.paramsChange.emit(this.params);
    }

    private loadStaticData() {
        forkJoin({
            productionPlaces: from(this.logistic.getProductionPlaces()),
            completionMethods: from(this.logistic.getPohCompletionMethods()),
            productionOrderMethods: from(this.logistic.getProdBeoMethods()),
            bookingGroups: from(this.product.getBookingGroups()),
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe((result) => {
                this.productionPlaces = result.productionPlaces;
                this.completionMethods = result.completionMethods;
                this.productionOrderMethods = result.productionOrderMethods;
                this.bookingGroups = result.bookingGroups;
                this.cdr.markForCheck();
            });
    }

    ngOnInit(): void {
        this.loadStaticData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.params = changes['params'].currentValue;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
